var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStressManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stress Management"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0002 12.5502C12.9943 12.5502 13.8002 11.7443 13.8002 10.7502C13.8002 9.75608 12.9943 8.9502 12.0002 8.9502C11.0061 8.9502 10.2002 9.75608 10.2002 10.7502C10.2002 11.7443 11.0061 12.5502 12.0002 12.5502Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.23973 21.5401V17.3601L7.67973 20.4601C7.50973 20.8001 7.15973 21.0101 6.78973 21.0101H3.46973C2.91973 21.0101 2.46973 20.5601 2.46973 20.0101C2.46973 19.4601 2.91973 19.0101 3.46973 19.0101H6.16973L8.33973 14.6901C8.51973 14.3401 8.86973 14.1401 9.23973 14.1401H14.7597C15.1297 14.1401 15.4797 14.3401 15.6597 14.6901L17.8297 19.0101H20.5297C21.0797 19.0101 21.5297 19.4601 21.5297 20.0101C21.5297 20.5601 21.0797 21.0101 20.5297 21.0101H17.2097C16.8397 21.0101 16.4897 20.8001 16.3197 20.4601L14.7597 17.3601V21.5401",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3797 15.91C13.7197 16.25 13.7197 16.8 13.3797 17.14L11.9897 18.53L10.5997 17.14C10.2597 16.8 10.2597 16.25 10.5997 15.91C10.9397 15.57 11.4897 15.57 11.8297 15.91L11.9797 16.06L12.1397 15.9C12.4797 15.56 13.0297 15.56 13.3697 15.9L13.3797 15.91Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.6705 15.6502L17.3605 13.9002C17.6505 13.4102 17.8705 12.8802 18.0205 12.3102L20.1905 12.0002C20.2605 11.5902 20.2905 11.1702 20.2905 10.7502C20.2905 10.3302 20.2605 9.91021 20.1905 9.50021L18.0205 9.19021C17.8705 8.63021 17.6505 8.09021 17.3605 7.60021L18.6705 5.85021C18.4305 5.51021 18.1505 5.19021 17.8605 4.90021C17.5605 4.60021 17.2405 4.33021 16.9105 4.09021L15.1605 5.40021C14.6705 5.11021 14.1405 4.89021 13.5705 4.74021L13.2605 2.57021C12.8505 2.50021 12.4305 2.47021 12.0105 2.47021C11.5905 2.47021 11.1705 2.50021 10.7605 2.57021L10.4505 4.74021C9.89047 4.89021 9.35047 5.11021 8.86047 5.40021L7.11047 4.09021C6.77047 4.33021 6.45047 4.61021 6.16047 4.90021C5.86047 5.20021 5.59047 5.52021 5.35047 5.85021L6.66047 7.60021C6.37047 8.09021 6.15047 8.62021 6.00047 9.19021L3.83047 9.50021C3.76047 9.91021 3.73047 10.3302 3.73047 10.7502C3.73047 11.1702 3.76047 11.5902 3.83047 12.0002L6.00047 12.3102C6.15047 12.8702 6.37047 13.4102 6.66047 13.9002L5.35047 15.6502",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressManagement);
export default __webpack_public_path__ + "static/media/Stress Management.e6e8338a3adc8514967f69a1e324d502.svg";
export { ForwardRef as ReactComponent };